import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { NewsBannerSlideModel } from '../../../models/news-banner.model';
import { NewsDialogComponent } from '../news-dialog/news-dialog.component';

@Component({
  selector: 'app-news-banner-card',
  templateUrl: './news-banner-card.component.html',
  styleUrl: './news-banner-card.component.scss',
  standalone: false,
})
export class NewsBannerCardComponent {
  @Input() newsBannerSlide: NewsBannerSlideModel;
  @Input() showButtons: boolean = true;
  @Output() onDelete: EventEmitter<NewsBannerSlideModel> = new EventEmitter();
  @Output() onEdit: EventEmitter<NewsBannerSlideModel> = new EventEmitter();
  public isDesktop: boolean = window.innerWidth > 1024;

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.isDesktop = event.target.innerWidth > 1024;
  }

  constructor(private dialog: DialogService) {}

  onDeleteClick(slide: NewsBannerSlideModel): void {
    this.onDelete.emit(slide);
  }

  onEditClick(slide: NewsBannerSlideModel): void {
    this.onEdit.emit(slide);
  }

  onCardClick(): void {
    if (this.isDesktop) {
      if (this.newsBannerSlide.link) {
        window.open(this.newsBannerSlide.link, '_blank');
      }
      return;
    }
    this.dialog.open(NewsDialogComponent, {
      header: this.newsBannerSlide.title,
      width: '50vw',
      style: { overflow: 'auto', 'max-width': '700px' },
      breakpoints: {
        '1024px': '70vw',
        '768px': '95vw',
      },
      data: this.newsBannerSlide,
    });
  }
}
